module.exports = __webpack_public_path__ + "assets/img/title2.bdd1e360.png";